export enum AssetRateTypes {
	BUY = 'buy',
	SELL = 'sell',
}
